import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import GroupBarchart from "../../../../../d3Components/NewBarchart/GroupBarchart";
import Spinner from "../../../../../common/spinner";
import Legend from "../../../../../d3Components/legend";
import ContainerDimensions from "react-container-dimensions";
import WithCard from "../../../../../common/withCard";

class BarchartHolder extends Component {
  state = {
    Data: [],
    xLabel: [
      {
        metric_name: "<-5%",
      },
      {
        metric_name: "<-5% to -4%",
      },
      {
        metric_name: "-4% to -3%",
      },
      {
        metric_name: "-3% to -2%",
      },
      {
        metric_name: "-2% to -1%",
      },
      {
        metric_name: "-1% to 0%",
      },
      {
        metric_name: "0% to 1%",
      },
      {
        metric_name: "1% to 2%",
      },
      {
        metric_name: "2% to 3%",
      },
      {
        metric_name: "3% to 4%",
      },
      {
        metric_name: "4% to 5%",
      },
      {
        metric_name: "5%>",
      },
    ],
    initialWidth: 0,
  };
  componentDidMount() {
    let { getMetricsForRange } = this.props;
    const { client_getMetricsForRange } = this.props;
    this.modifyData({
      getMetricsForRange: getMetricsForRange,
      client_getMetricsForRange: client_getMetricsForRange,
    });
  }
  componentWillReceiveProps(nextProps) {
    let { client_getMetricsForRange, getMetricsForRange } = nextProps;

    this.modifyData({
      getMetricsForRange: getMetricsForRange,
      client_getMetricsForRange: client_getMetricsForRange,
    });
  }
  modifyData = ({ getMetricsForRange, client_getMetricsForRange } = []) => {
    if (getMetricsForRange && client_getMetricsForRange) {
      let data = [];
      for (let i = 0; i < getMetricsForRange.length; i++) {
        let obj = { ...getMetricsForRange[i] };
        obj["metric_name"] = this.state.xLabel[i]["metric_name"];
        obj["Original Portfolio"] = client_getMetricsForRange[i]["funds"];
        data.push(obj);
      }
      this.setState({
        Data: data,
      });
    } else if (getMetricsForRange) {
      let data = [];
      for (let i = 0; i < getMetricsForRange.length; i++) {
        let obj = { ...getMetricsForRange[i] };
        obj["metric_name"] = this.state.xLabel[i]["metric_name"];
        data.push(obj);
      }
      this.setState({
        Data: data,
      });
    }
  };
  render() {
    const { Data } = this.state;
    const {
      typeName,
      benchmark_name,
      display_orig_portfolio,
      model_name,
    } = this.props;
    return (
      <WithCard>
        <h4 className="text-uppercase bold">Returns Distribution</h4>
        {Data.length ? (
          <div style={{ overflowX: "auto" }}>
            <ContainerDimensions>
              {({ width }) => (
                <Fragment>
                  <Legend
                    height={30}
                    width={width}
                    legend1={
                      display_orig_portfolio
                        ? `IQCIO Model ${model_name ? "+" : ""}`
                        : "Portfolio"
                    }
                    legend2={display_orig_portfolio ? "Benchmark *" : typeName}
                    legend3={
                      display_orig_portfolio ? "Original Portfolio" : null
                    }
                  />
                  {width > 0 ? (
                    <GroupBarchart
                      containerWidth={width}
                      height={300}
                      data={Data}
                      toolTipPercent={false}
                      targetDiv="yearly_barChart_returns"
                    />
                  ) : null}
                </Fragment>
              )}
            </ContainerDimensions>
            {benchmark_name && display_orig_portfolio ? (
              <div>
                <b>*</b> <small>{benchmark_name}</small>
              </div>
            ) : null}
            {model_name ? (
              <div>
                <small>
                  <b>+</b> {model_name}
                </small>
              </div>
            ) : null}
          </div>
        ) : (
          <div className="py-5">
            <Spinner />
          </div>
        )}
      </WithCard>
    );
  }
}

export default connect(
  ({
    create: {
      steps: {
        risk: { benchmark_name, display_orig_portfolio },
        universeLite: {
          analyze_compare,

          analyze_compare: {
            clientBacktestData: { getMetricsForRange },
          },
          model_name,
        },
      },
    },
  }) => ({
    benchmark_name,
    analyze_compare,
    display_orig_portfolio,
    client_getMetricsForRange: getMetricsForRange,
    model_name,
  }),
  null
)(BarchartHolder);



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/Returns/section1/barchartHolder.jsx